export default __webpack_public_path__ + "static/feature_mb_01-8a3fa04c7617a32783d62b720bd2061a.png";